import router from '../../../router'
import { SortedTable, SortLink } from 'vue-sorted-table'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputText from '../../../components/input-text/InputText'
import InputCheckbox from '../../../components/input-checkbox/InputCheckbox'
import InputDropdownFilter from '../../../components/input-dropdown-filter/InputDropdownFilter'
import InputDropdownCheckbox from '../../../components/input-dropdown-checkbox/InputDropdownCheckbox'
import InputButton from '../../../components/input-button/InputButton'
import Loader from '../../../components/loader/Loader'
import SettingsHeader from '../../../components/settings-header/SettingsHeader'
import { CustomerService, Customer, CustomerSettings } from '../../../services/customer.service'
import { LocationService, LocationDropdown, Location } from '../../../services/location.service'
import { Constants } from '../../../constants'
import { ScreenLoader } from '../../../utils/loading.util'
import { Entity } from '../../../services/entity.service'
import Card from '../../../components/card/Card'

export default {
    name: 'Customer',

    components: {
        NavigationBar,
        TabBar,
        InputText,
        InputCheckbox,
        InputDropdownFilter,
        InputDropdownCheckbox,
        InputButton,
        Loader,
        SettingsHeader,
        SortedTable,
        SortLink,
        Card
        // ScaleOut
    },

    data() {
        return {
            customer: new Customer(),
            locations: [],
            selectedEntityLocationId: undefined,
            selectedSpotLocationId: undefined,
            dropdownLocations: [],
            dropdownEntities:[],
            dropdownSpots:[],
            screenLoader: new ScreenLoader(),
            customerSettings: undefined
        }
    },

    async mounted() {
        this.screenLoader.start(['customer'])
        try {
            const locations = await LocationService.getLocations()
            this.locations = locations.map(l => new Location(l))
            this.dropdownLocations = locations.map(o => new LocationDropdown(o))
            if (this.$route.params.id != 'new') {
                const customer = await CustomerService.getCustomer(this.$route.params.id)
                this.customer = new Customer(customer)
                this.screenLoader.stop(['customer'])
            }else{
                this.screenLoader.stop(['customer'])
            }

        } catch (err) {
            this.screenLoader.stopWithError(error)
        }
    },

    methods: {
        doClear(reference) {
            this.customer[reference] = ''
        },

        doSave() {
            if (this.customer.name) {
                if (this.customer.id == undefined) {
                    this.createCustomer()
                }else{
                    this.updateCustomer()
                }
            }else{
                for (const ref in this.$refs) {
                    if (this.$refs[ref] != undefined) {
                        this.$refs[ref].checkForError()
                    }
                }
            }
        },

        doCancel() {
            router.push(`/settings/customers`)
        },

        toggleAllowSetTimeSlotLength() {
            this.customer.allowSetTimeSlotLength = !this.customer.allowSetTimeSlotLength
        },

        createCustomer: async function() {
            this.screenLoader.start()

            try {
                if(this.customer.emailAddress == ""){
                    this.customer.emailAddress = undefined
                }
                const response = await CustomerService.createCustomer(this.customer)
                this.handleMutateCustomerResponse(response, 'The customer has been successfully created')
            } catch (error) {
                if(error.errorCode == 400){
                    if (error.message.errorAtEntry == "emailAddress"){
                        await this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: error.errorCode, message: "Email address is not a valid email address"})

                    }
                }
                this.screenLoader.stopWithError(error)
            }
        },

        updateCustomer: async function() {
            this.screenLoader.start()

            try {
                if(this.customer.emailAddress == ""){
                    this.customer.emailAddress = undefined
                }
                const response = await CustomerService.updateCustomer(this.customer)
                this.handleMutateCustomerResponse(response, 'The customer has been successfully updated')
            } catch (error) {

                if(error.errorCode == 400){
                    if (error.message.errorAtEntry == "emailAddress"){
                        await this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: error.errorCode, message: "Email address is not a valid email address"})

                    }
                }

                this.screenLoader.stopWithError(error)

            }
        },


        handleMutateCustomerResponse(response, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: message })
            router.push(`/settings/customers`)
        },

        addLocation(id) {
            const location = this.customer.locations.filter(location => location.id == id)
            if (location.length == 0) {
                this.customer.locations.push(this.locations.filter(location => location.id == id)[0])
            }
        },

        removeLocation(id) {
            this.customer.locations = this.customer.locations.filter(location => location.id != id)
        },

        async addLocationSpots(location) {
            const locationResponse = await LocationService.getLocation(location.id)
            this.customerSettings = new CustomerSettings(location, locationResponse.groups, undefined, 0)
        },

        submitCustomerSettings(settings) {
            settings.location.spots = settings.locationSpots
            // Find and update the correct location within the customer locations
            const index = this.customer.locations.findIndex(
                location => location.id === settings.location.id
            );

            if (index !== -1) {
                // Update the specific location object
                this.customer.locations[index] = settings.location;
            }            this.customerSettings = undefined
        },

        removeSpot(location, spot) {
            location.spots = location.spots?.filter(s => s.id !== spot.id)
        },

        removeEntity(location, entity) {
            location.entities = location.entities?.filter(entities => entities.id !== entity.id)
        },

        async addLocationEntities(location) {
            const locationResponse = await LocationService.getLocation(location.id)
            locationResponse.groups.forEach((group) => {
                group.entities = group.entities?.map(e => new Entity(e))
            })
            this.customerSettings = new CustomerSettings(location, locationResponse.groups, undefined,1)
        },

        async editSpots(location, entity){
            const locationResponse = await LocationService.getLocation(location.id)
            locationResponse.groups.forEach((group) => {
                group.entities = group.entities?.map(e => new Entity(e))
            })
            this.customerSettings = new  CustomerSettings(location, locationResponse.groups, entity, 2)
        },

        toggleActive () {
            this.customer.active = !this.customer.active
        }
    }

}
